module.exports = __webpack_public_path__ + "media/hyper/fonts/materialdesignicons-webfont-bbe05489cd38a31d16943d116fe98de5.ttf";